import { Component } from '@angular/core';

@Component({
  selector: 'mtm-orange-circle-icon',
  templateUrl: './orange-circle-icon.component.html',
  styleUrls: [],
  standalone: false,
})
export class OrangeCircleIconComponent {}
